<script setup lang="ts">
import Modal from '@/components/Modal.vue'
import {IonButton, IonIcon} from '@ionic/vue'
import {computed, onMounted, ref, watch} from 'vue'
import {useEmployeeStore} from '@/store/employee'
import {useAuthStore} from '@/store/auth'

const model = defineModel<boolean>({ default: false });
const employeeStore = useEmployeeStore()
const authStore = useAuthStore()
const frame = ref()
const isEditing = ref(false)
const fraginesURL = import.meta.env.VITE_FRAGINES_ENDPOINT

const slug = computed(() => employeeStore.storedEmployee?.slug)

const onClickButtonEdit = () => {
    isEditing.value = true

    frame.value.contentWindow.postMessage({
        action: 'edit',
        jwt: authStore.jwt_string,
        username: authStore.isImpersonating() ? authStore.getImpersonationUsername() : undefined
    }, fraginesURL)
}

const onClickButtonDone = () => {
    isEditing.value = false

    frame.value.contentWindow.postMessage({
        action: 'done',
    }, fraginesURL)
}

onMounted(() => {
    window.addEventListener('message', e => {
        const payload = e.data

        if (payload.action === 'copytoclipboard') {
            navigator.clipboard.writeText(payload.value)
        }

        if (payload.action === 'requesting_initial_edit') {
            onClickButtonEdit()
        }
    })
})

watch(model, value => {
    if (!value) {
        isEditing.value = false
    }
})
</script>

<template>
<Modal
    v-model="model"
    toolbar
    transparent-toolbar
    fullscreen
    class="no-padding-left no-padding-right no-padding-top no-padding-bottom"
>
    <iframe ref=frame class="employee-sedcard-iframe" :src="`${fraginesURL}/über/${slug}`" />
    <template v-slot:toolbar-end>
        <ion-button
            v-if="!isEditing"
            @click="onClickButtonEdit"
            shape="round"
            fill="solid"
            color="light"
            size="small"
            style="max-width: none; width: auto"
        >
            <ion-icon
                color="secondary"
                size="small"
                src="/icons/pencil-simple.svg"
                slot="start"
            />
            Bearbeiten
        </ion-button>


        <ion-button
            v-else
            @click="onClickButtonDone"
            shape="round"
            fill="solid"
            color="primary"
            size="small"
            style="max-width: none; width: auto"
        >
            <ion-icon
                size="small"
                src="/icons/check.svg"
                slot="start"
            />
            Fertig
        </ion-button>
    </template>
</Modal>
</template>

<style lang="scss">
.employee-sedcard-iframe {
    border: 0;
    border-radius: 0;
    width: 100%;
    height: 100%;
}
</style>
